import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  Youtube,
  Mail,
  MapPin,
  ShieldCheck,
  Leaf,
} from "lucide-react";
import { NAV_LINKS, SOCIALS, SITE } from "@/constants/site";

const iconMap = { facebook: Facebook, instagram: Instagram, youtube: Youtube, mail: Mail };

export const Footer = () => {
  return (
    <footer
      className="border-t border-halalgo-kraft-100 bg-halalgo-paper2"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          {/* Brand column */}
          <div>
            <img
              src={SITE.logo}
              alt="Halal GO"
              className="h-12 w-12 rounded-lg ring-1 ring-halalgo-kraft-200"
              width={48}
              height={48}
            />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-halalgo-ink/70">
              Your trusted halal food delivery in the Philippines. Support local,
              eat halal, live easy.
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIALS.map((s) => {
                const Icon = iconMap[s.icon] || Mail;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    data-testid={`footer-social-${s.icon}`}
                    className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-halalgo-kraft-200 bg-white text-halalgo-ink/70 transition-colors hover:border-halalgo-green-300 hover:text-halalgo-green-700"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-halalgo-kraft-700">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.testId}`}
                    className="text-sm text-halalgo-ink/75 transition-colors hover:text-halalgo-green-800"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + trust */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-halalgo-kraft-700">
              Get in touch
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-halalgo-ink/75">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-halalgo-green-700" /> {SITE.email}
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-halalgo-green-700" /> {SITE.location}
              </li>
            </ul>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-md border border-halalgo-green-200 bg-halalgo-green-50 px-2.5 py-1 text-xs font-medium text-halalgo-green-800">
                <ShieldCheck className="h-3.5 w-3.5" /> 100% Halal
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md border border-halalgo-kraft-200 bg-halalgo-kraft-50 px-2.5 py-1 text-xs font-medium text-halalgo-kraft-800">
                <Leaf className="h-3.5 w-3.5" /> Eco Packaging
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-halalgo-kraft-200 pt-6 sm:flex-row">
          <p
            className="text-center text-sm font-semibold text-halalgo-ink sm:text-left"
            data-testid="footer-tagline"
          >
            Proudly in the Philippines. Serving Halal with Integrity.
          </p>
          <p className="text-xs text-halalgo-ink/55">
            © {new Date().getFullYear()} Halal GO. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
